import { Padrao } from '../generic/padrao';
import { Pessoa } from '../pessoa/pessoa';

export class PessoaCatalogo extends Padrao{

    override idTab = 268;

    pessoa: Pessoa = new Pessoa();
    nome: string;
    cpf: string;
    telefone: string;
    
}